export const PROJECT_TYPES = ['DATASET', 'DASHBOARD', 'ARTICLE', 'WEB_APP'];
export const TYPES = PROJECT_TYPES.concat(['APP', 'LINK']);
